import { Box, TextInput } from '@mantine/core';
import { useCellSelector } from './use-cell-selector';
import type { InputProps } from '../../types';
import { useDebouncedDraft } from '../../hooks/use-debounced-draft';
import { Clipboard, CellClipboard, Reset } from '@morph-mapper/ui';

export const CellSelector = ({ value, handleChange }: InputProps<string>) => {
  const { handleSetCellPath, handleSetTextPath, handleClearPath } =
    useCellSelector(handleChange);

  const inputValue = value ?? '';
  const [draft, setDraft] = useDebouncedDraft(inputValue, handleChange);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <CellClipboard size={'lg'} mr={'md'} onClick={handleSetCellPath} />
      <Clipboard size={'lg'} mr={'md'} onClick={handleSetTextPath} />
      {inputValue !== '' && (
        <Reset
          size={'lg'}
          mr={'md'}
          onClick={handleClearPath}
          variant="default"
        />
      )}
      <TextInput
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        sx={{ flexGrow: 1 }}
      />
    </Box>
  );
};
